import React from 'react';

import './index.scss';

export default class CashPaymentNotice extends React.Component {
  _paymentInfo() {
    let text;
    let { total_in_local_currency_formatted } = this.props;

    if (
      this.props.total_in_local_currency_formatted !==
      this.props.total_formatted
    ) {
      text = `Please pay in the local currency amount of ${total_in_local_currency_formatted}.`;
    }

    return text;
  }

  render() {
    return (
      <div className="CheckoutSummary-ContentBox CashPaymentNotice">
        <div className="CheckoutSummary-CashPaymentNotice">
          <p>
            Amount due in <strong>cash</strong> when you arrive on
            <br />
            <strong>{this.props.date}</strong>. {this._paymentInfo()}
          </p>
        </div>
      </div>
    );
  }
}
